export default __webpack_public_path__ + "static/media/hero-bg.7e57c5b3.png";